export interface ApiError {
  code: string;
  message: string;
  debug_info?: any;
  description?: string;
}

export type SuccessResponse<T> = {
  success: true;
  payload: T;
  message?: string;
  description?: string;
  headers?: Record<string, unknown>;
};

export type ErrorResponse = {
  success: false;
  error: ApiError;
  message?: string;
  description?: string;
  errors?: ApiError;
};

export type ApiResponse<T> = SuccessResponse<T> | ErrorResponse;

export const buildSuccessResponse = <T>(
  message: string,
  description: string | null,
  data: T,
): SuccessResponse<T> => {
  return {
    success: true,
    payload: data,
    message,
    description: description || undefined,
  };
};

export const buildErrorResponse = (
  message: string,
  description: string | null,
  error: ApiError = {} as ApiError,
): ErrorResponse => {
  return {
    success: false,
    message,
    description: description || undefined,
    error,
  };
};

export const buildErrorResponseFromError = (error: Error): ErrorResponse => {
  return {
    success: false,
    message: error.message,
    description: '',
    error: {} as ApiError,
  };
};
